import { __awaiter, __generator } from "tslib";
import { fetchPost } from '../../../common/http/fetch-post';
import { getPricingApiConfig } from '../config/actions';
import { getFetchPricesUrlPost } from '../utilities/get-fetch-prices-url.post';
/**
 * @internal
 */
export var fetchPricesPost = function (entityIds, productType) { return __awaiter(void 0, void 0, void 0, function () {
    var url, marketLocale;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = getFetchPricesUrlPost(productType);
                marketLocale = getPricingApiConfig().marketLocale;
                return [4 /*yield*/, fetchPost(url, { groupIds: entityIds, marketLocale: marketLocale })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
